import { cn } from "../../magicui/lib/utils";
import {
  IconAdjustmentsBolt,
  IconCloud,
  IconCurrencyDollar,
  IconEaseInOut,
  IconHeart,
  IconHelp,
  IconRouteAltLeft,
  IconTerminal2,
} from "@tabler/icons-react";

export function ProjectsImpact() {
  const features = [
    {
      title: "Diverse Project Domains",
      description:
        "Explore fields like AI, Web Development, IoT, and more.",
      icon: <IconTerminal2 />,
    },
    {
      title: "Real-World Challenges",
      description:
        "Tackle industry-level problems to enhance practical skills.",
      icon: <IconEaseInOut />,
    },
    {
      title: "Live Expert Mentorship",
      description:
        "Continuous guidance from industry professionals.",
      icon: <IconCurrencyDollar />,
    },
    {
      title: "Comprehensive Documentation",
      description: "Full access to source code and detailed project reports.",
      icon: <IconCloud />,
    },
    {
      title: "Interactive Presentations",
      description: "Deliver project presentations with complete support.",
      icon: <IconRouteAltLeft />,
    },
    {
      title: "Recognized Certifications",
      description:
        "Earn professional certification for each completed project.",
      icon: <IconHelp />,
    },
    {
      title: "Portfolio Building",
      description:
        "Strengthen your resume with hands-on projects.",
      icon: <IconAdjustmentsBolt />,
    },
    {
      title: "Flexible Learning Resources",
      description: "Access quizzes, assignments, and reading materials anytime.",
      icon: <IconHeart />,
    },
  ];
  return (
    <div>
      <div className="w-full text-center py-8 lg:py-16">
        <span className="text-themepruple font-medium text-base">What you will get</span>
        <h1 className="text-[#101828] text-xl md:text-2xl lg:text-4xl font-semibold my-3">The Impact of Our Projects on Your Growth</h1>
        <p className="text-[#475467] text-base md:text-xl font-normal">Enhance your skills, build your portfolio, and connect with industry leaders.</p>
      </div>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4  relative z-10 py-10 max-w-7xl mx-auto ">
      {features.map((feature, index) => (
        <Feature key={feature.title} {...feature} index={index} />
      ))}
    </div>
    </div>
  );
}

const Feature = ({
  title,
  description,
  icon,
  index,
}: {
  title: string;
  description: string;
  icon: React.ReactNode;
  index: number;
}) => {
  return (
    <div
      className={cn(
        "flex flex-col lg:border-r  py-10 relative group/feature dark:border-neutral-800 ",
        (index === 0 || index === 4) && "lg:border-l dark:border-neutral-800",
        index < 4 && "lg:border-b dark:border-neutral-800"
      )}
    >
      {index < 4 && (
        <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-t from-neutral-100 dark:from-neutral-800 to-transparent pointer-events-none" />
      )}
      {index >= 4 && (
        <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-b from-neutral-100 dark:from-neutral-800 to-transparent pointer-events-none" />
      )}
      <div className="mb-4 relative z-10 px-10 text-neutral-600 dark:text-neutral-400">
        {icon}
      </div>
      <div className="text-lg font-bold mb-2 relative z-10 px-10">
        <div className="absolute left-0 inset-y-0 h-6 group-hover/feature:h-8 w-1 rounded-tr-full rounded-br-full bg-neutral-300 dark:bg-neutral-700 group-hover/feature:bg-themepruple transition-all duration-200 origin-center" />
        <span className="group-hover/feature:translate-x-2 transition duration-200 inline-block text-neutral-800 dark:text-neutral-100">
          {title}
        </span>
      </div>
      <p className="text-sm text-neutral-600 dark:text-neutral-300 max-w-xs relative z-10 px-10">
        {description}
      </p>
    </div>
  );
};
